/**
 * @generated SignedSource<<4132721eddadc38e6ddf4e6f1028c62d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutSidebarSidemarkForm_viewer$data = {
  readonly isMultiStageCheckoutOn: boolean | null;
  readonly " $fragmentType": "CheckoutSidebarSidemarkForm_viewer";
};
export type CheckoutSidebarSidemarkForm_viewer$key = {
  readonly " $data"?: CheckoutSidebarSidemarkForm_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSidebarSidemarkForm_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutSidebarSidemarkForm_viewer",
  "selections": [
    {
      "alias": "isMultiStageCheckoutOn",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "multiStageCheckout"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"multiStageCheckout\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "72aa3eab0c08024d0cbac6975c47aee7";

export default node;
